export { default } from './H6';
